module.exports = __webpack_public_path__ + "static/DownfallCoverSliderImage-1e37d2f79fad8dc322ef134595756e2e.jpeg";